import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const LocationInfoSection = () => {
  const locationFeatures = [
    {
      id: 1,
      icon: "MapPin",
      title: "Localização Estratégica",
      description:
        "No Altiplano Leste, Paranoá, com fácil acesso por transporte público e particular",
      details: [
        "Próximo ao Privê Morada Sul",
        "Próximo ao Jardim Botânico",
        "Próximo ao Lago Sul"
      ],
    },
    {
      id: 2,
      icon: "Car",
      title: "Estacionamento Disponível",
      description:
        "Vagas de estacionamento para clientes e visitantes",
      details: ["Vagas na estação", "Acesso facilitado", "Área segura"],
    },
    {
      id: 3,
      icon: "Shield",
      title: "Segurança",
      description:
        "Medidas de segurança adequadas para garantir tranquilidade dos visitantes",
      details: ["Iluminação adequada", "Área monitorada", "Local seguro"],
    },
    {
      id: 4,
      icon: "Accessibility",
      title: "Acessibilidade Básica",
      description:
        "Estrutura adaptada para facilitar o acesso de todos os visitantes",
      details: [
        "Acesso principal nivelado",
        "Corredores amplos",
        "Circulação facilitada",
      ],
    },
    {
      id: 5,
      icon: "ShoppingBag",
      title: "Agência Mercado Livre",
      description: "Ponto oficial de apoio e envios do Mercado Livre",
      details: ["Recebimento de encomendas", "Envios para todo o Brasil", "Suporte ao vendedor"],
    },
    {
      id: 6,
      icon: "Droplets",
      title: "Tratamento de Esgoto Próprio",
      description: "Estação de tratamento de esgoto dedicada ao empreendimento",
      details: ["Operação local", "Mais autonomia", "Infraestrutura completa"],
    },
  ];

  const operatingHours = [
    { day: "Segunda-feira", hours: "06:00 - 23:00" },
    { day: "Terça-feira", hours: "06:00 - 23:00" },
    { day: "Quarta-feira", hours: "06:00 - 23:00" },
    { day: "Quinta-feira", hours: "06:00 - 23:00" },
    { day: "Sexta-feira", hours: "06:00 - 23:00" },
    { day: "Sábado", hours: "06:00 - 23:00" },
    { day: "Domingo", hours: "06:00 - 23:00" },
  ];

  const transportOptions = [
    {
      type: "Jardim Botânico",
      icon: "Home",
      description: "Ponto de referência próximo",
      distance: "23 min",
      walkTime: "De carro",
    },
    {
      type: "Ponte JK",
      icon: "Construction",
      description: "Acesso pela Ponte JK",
      distance: "14 min",
      walkTime: "De carro",
    },
    {
      type: "Condomínio Privê Morada Sul",
      icon: "Home",
      description: "Av. Altiplano Leste - Próximo",
      distance: "5 min",
      walkTime: "A pé",
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            Localização e Facilidades
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Estrategicamente localizado com todas as comodidades para sua
            conveniência e segurança
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16 text-center lg:[&>*:nth-last-child(-n+2)]:col-span-2 lg:[&>*:nth-last-child(-n+2)]:justify-self-center">
          {locationFeatures?.map((feature) => (
            <div
              key={feature?.id}
              className="text-center p-6 bg-card rounded-xl border border-border hover:shadow-warm transition-all duration-300 hover:scale-105"
            >
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name={feature?.icon} size={32} className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-3">
                {feature?.title}
              </h3>
              <p className="text-muted-foreground mb-4 leading-relaxed">
                {feature?.description}
              </p>
              <ul className="space-y-1">
                {feature?.details?.map((detail, index) => (
                  <li
                    key={index}
                    className="text-sm text-muted-foreground flex items-center justify-center"
                  >
                    <Icon
                      name="Check"
                      size={14}
                      className="text-green-600 mr-2"
                    />
                    {detail}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Location Details */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {/* Map */}
          <div className="bg-card rounded-xl border border-border overflow-hidden">
            <div className="p-6 border-b border-border">
              <h3 className="text-xl font-semibold text-foreground mb-2">
                Nossa Localização
              </h3>
              <p className="text-muted-foreground">
                Altiplano Leste - Paranoá, Brasília - DF, 71680-900, Brasil
              </p>
            </div>
            <div className="h-64 lg:h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.123456789!2d-47.8901234!3d-15.7801234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935a23a3873fee5b%3A0x32b4613b357c717c!2sAltiplano%20Leste%20-%20Parano%C3%A1%2C%20Bras%C3%ADlia%20-%20DF!5e0!3m2!1spt-BR!2sbr!4v1760316412799!5m2!1spt-BR!2sbr"
                width="100%"
                height="1024"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização da Estação Marina da Rocha - Altiplano Leste - Paranoá, Brasília"
              ></iframe>
            </div>
          </div>

          {/* Operating Hours & Transport */}
          <div className="space-y-8">
            {/* Operating Hours */}
            <div className="bg-card rounded-xl border border-border p-6">
              <h3 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Icon name="Clock" size={24} className="text-primary mr-3" />
                Horário de Funcionamento
              </h3>
              <div className="space-y-3">
                {operatingHours?.map((schedule, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center py-2 border-b border-border last:border-b-0"
                  >
                    <span className="text-foreground font-medium">
                      {schedule?.day}
                    </span>
                    <span className="text-muted-foreground">
                      {schedule?.hours}
                    </span>
                  </div>
                ))}
              </div>
              <div className="mt-4 p-3 bg-accent/10 rounded-lg">
                <p className="text-sm text-accent-foreground flex items-center">
                  <Icon name="Info" size={16} className="mr-2" />
                  Horário único todos os dias da semana
                </p>
              </div>
            </div>

            {/* Transport Options */}
            <div className="bg-card rounded-xl border border-border p-6">
              <h3 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Icon
                  name="Navigation"
                  size={24}
                  className="text-primary mr-3"
                />
                Como Chegar
              </h3>
              <div className="space-y-4">
                {transportOptions?.map((transport, index) => (
                  <div
                    key={index}
                    className="flex items-start space-x-4 p-3 bg-muted/30 rounded-lg"
                  >
                    <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon
                        name={transport?.icon}
                        size={20}
                        className="text-primary"
                      />
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-foreground">
                        {transport?.type}
                      </h4>
                      <p className="text-sm text-muted-foreground mb-1">
                        {transport?.description}
                      </p>
                      <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                        <span className="flex items-center">
                          <Icon name="MapPin" size={12} className="mr-1" />
                          {transport?.distance}
                        </span>
                        <span className="flex items-center">
                          <Icon name="Clock" size={12} className="mr-1" />
                          {transport?.walkTime}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationInfoSection;
